import {
	FETCH_USER_DATA,
	FETCH_POSTS,
	SHOW_ALERT,
	RESET_USER_MODULE,
	UPDATE_FIREBASE_TOKEN
} from "../action-types";
import {
	fetchUserDataSuccess,
	fetchPostsSuccess,
	resetUserModule
} from "../mutation-types";
import { DEFAULT_ERROR_MESSAGE, DASHBOARD_LAMBDA_API } from "../config";
import { BASE_URL } from "../../../config";
import ApiService from "../api-service";

const state = {
	userData: null,
	userPosts: [],
	userPostsLastEvalKey: null,
	SECRET_PASSCODE: null
};

const initialState = Object.assign({}, state);

const actions = {
	[FETCH_USER_DATA.action]: ({ commit, rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/user/v1.0.0/dashboard";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			action: "getUserDetail",
			params: {},
			...payload
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						if (typeof data.response.Item === "object") {
							commit(fetchUserDataSuccess, {
								payload: data.response.Item
							});
							return;
						}
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				let errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[FETCH_POSTS.action]: ({ commit, state, rootState, dispatch }, payload) => {
		let endpoint = DASHBOARD_LAMBDA_API + "/news-analytics";
		let requestPayload = {
			userId: rootState.auth.USERID,
			access_token: rootState.auth.ACCESS_TOKEN,
			...(payload === "end"
				? { LastEvaluatedKey: state.userPostsLastEvalKey }
				: {})
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				if (typeof data === "object" && "errorMessage" in data) {
					// commit("showAlert", { text: data.errorMessage });
					errMsg = data.errorMessage;
					if (data.errorMessage === "Not authorized") {
						if (
							confirm(
								"Your session has expired. Click OK to login again."
							)
						) {
							commit("resetAppState");
						}
					}
				} else if ("items" in data) {
					commit(fetchPostsSuccess, {
						dir: payload,
						data
					});
					return;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[RESET_USER_MODULE.action]: ({ commit }) => {
		commit(resetUserModule);
	},
	[UPDATE_FIREBASE_TOKEN.action]: (
		{ commit, rootState, dispatch },
		payload
	) => {
		const { token } = payload;
		let endpoint = BASE_URL + "/jeet11-retail/v1.0.0/setRetailerSetting";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				pwaFcmToken: token
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				if (typeof data === "object" && "errorMessage" in data) {
					// commit("showAlert", { text: data.errorMessage });
					errMsg = data.errorMessage;
					if (data.errorMessage === "Not authorized") {
						if (
							confirm(
								"Your session has expired. Click OK to login again."
							)
						) {
							commit("resetAppState");
						}
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	}
};

const mutations = {
	[fetchUserDataSuccess](state, { payload }) {
		state.userData = {
			...payload
		};
		state.SECRET_PASSCODE = payload.passCode ? payload.passCode.S : null;
	},
	[fetchPostsSuccess](state, { dir, data }) {
		let acceptedPostsType = [
			"video",
			"image",
			"text",
			"gif",
			"audio",
			"link"
		];
		const filteredPosts = data.items.filter(el =>
			acceptedPostsType.includes(el.type.S)
		);
		if (dir === "end") {
			state.userPosts = state.userPosts.concat(filteredPosts);
		} else {
			state.userPosts = filteredPosts;
		}
		state.userPostsLastEvalKey = data.LastEvaluatedKey;
	},
	[resetUserModule](state) {
		Object.keys(initialState).map(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
